module.exports = __webpack_public_path__ + "static/media/delivery.3b155ecb.jpg";